// GENERAL LAYOUT FOR MAIN MENU INSIDE GLOBAL HEADER

import React, { useContext, useRef, useState, useEffect } from 'react';
import './submenu.scss';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// CONTEXT
import { secundaryPagesContext } from '../../../../contexts/pages/aboutus/secundaryPages/secundaryPagesContext';
import curriculumContext from '../../../../contexts/pages/curriculum/curriculumContext';
import { videoPlayerContext } from '../../../../contexts/helpers/videoPlayer/videoPlayerContext';

const admisiones = "https://babeque.edupage.org/register/";

const Main = ({ setMainState, aboutState, setAboutState, curriculumState, setCurriculumState }) => {

    // Get states
    const SecundaryPagesContext = useContext(secundaryPagesContext);
    const { setFoundationState, setPhilosophyState, setDepartmentsState, setCommitmentState, setAnthemState, setVirtualTourState } = SecundaryPagesContext;

    const CurriculumContext = useContext(curriculumContext);
    const { setStudentProfileState,
        setAcademicAreasState,
        setAlliesState,
        setToolsState,
        setCocurricularState,
    } = CurriculumContext;

    const VideoPlayerContext = useContext(videoPlayerContext);
    const { handleDeactivatePlayer } = VideoPlayerContext;

    const activitiesLink = "https://centrocultural.secundariababeque.edu.do/";

    // Control de desplazamiento horizontal y visibilidad de flechas en pantallas intermedias (780px - 1100px)
    const scrollRef = useRef(null);
    const [hasOverflow, setHasOverflow] = useState(false);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollState = () => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            const overflow = scrollWidth > clientWidth + 4;
            setHasOverflow(overflow);
            setCanScrollLeft(scrollLeft > 6);
            setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 6);
        }
    };

    useEffect(() => {
        updateScrollState();
        const el = scrollRef.current;
        if (el) {
            el.addEventListener('scroll', updateScrollState, { passive: true });
        }
        window.addEventListener('resize', updateScrollState);
        const timer = setTimeout(updateScrollState, 250);
        return () => {
            if (el) el.removeEventListener('scroll', updateScrollState);
            window.removeEventListener('resize', updateScrollState);
            clearTimeout(timer);
        };
    }, []);

    const handleScrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: -260, behavior: 'smooth' });
        }
    };

    const handleScrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: 260, behavior: 'smooth' });
        }
    };

    async function scrollTo(cb, ms) {
        return new Promise(resolve => {
            setTimeout(cb, ms);
        });
    }

    return (
        <div className="submenu submenu-main">
            {hasOverflow && (
                <button
                    type="button"
                    className={`submenu-nav-arrow submenu-nav-arrow--left ${canScrollLeft ? 'is-active' : 'is-disabled'}`}
                    onClick={handleScrollLeft}
                    disabled={!canScrollLeft}
                    aria-label="Desplazar menú hacia la izquierda"
                    title="Ver opciones anteriores a la izquierda"
                >
                    <FaChevronLeft />
                </button>
            )}

            <div className="links-group" ref={scrollRef}>
                <div className="links">
                    <Link to="/conocenos"
                        onClick={() => {
                            handleDeactivatePlayer();
                            setFoundationState({ enter: false, active: true });
                            setPhilosophyState({ enter: false, active: false });
                            setCommitmentState({ enter: false, active: false });
                            setDepartmentsState({ enter: false, active: false });
                            setAnthemState({ enter: false, active: false });
                            setVirtualTourState({ enter: false, active: false });
                            scrollTo(() => {
                                if (document.querySelector(".aboutus-subpage"))
                                    document.querySelector(".aboutus-subpage").scrollIntoView({ behavior: "smooth", block: "start" });
                            }, 500);
                        }}
                    >
                        <h6>CONÓCENOS</h6>
                    </Link>
                    <div className="fg"></div>
                </div>
                <div className="border-left"></div>
                <div className="links">
                    <Link to="/curriculum" onClick={() => {
                        setStudentProfileState({ enter: false, active: false });
                        setAcademicAreasState({ enter: false, active: false });
                        setAlliesState({ enter: false, active: false });
                        setToolsState({ enter: false, active: false });
                        setCocurricularState({ enter: false, active: false });
                    }}>
                        <h6>CURRICULUM</h6>
                    </Link>
                    <div className="fg"></div>
                </div>
                <div className="border-left"></div>
                <div className="links">
                    <Link to="/curriculum/bachillerato-ib">
                        <h6>BACHILLERATO INTERNACIONAL</h6>
                    </Link>
                    <div className="fg"></div>
                </div> 
                <div className="border-left"></div>
                <div className="links">
                    <a href={admisiones} target="_blank" rel="noopener noreferrer">
                        <h6>ADMISIONES</h6>
                    </a>
                    <div className="fg"></div>
                </div>
                <div className="border-left"></div>
                <div className="links">
                    <Link to="/actividades">
                        <h6>ACTIVIDADES</h6>
                    </Link>
                    <div className="fg"></div>
                </div>
                
                <div className="border-left"></div>
                <div className="links">
                    <a href={`${activitiesLink ?? ""}`} target="_blank" rel="noopener noreferrer">
                        <h6>CENTRO SOCIOCULTURAL BABEQUE</h6>
                    </a>
                    <div className="fg"></div>
                </div>  
                <div className="border-left"></div>
                <div className="links">
                    <Link to="/contactanos">
                        <h6>CONTÁCTANOS</h6>
                    </Link>
                    <div className="fg"></div>
                </div>
            </div>

            {hasOverflow && (
                <button
                    type="button"
                    className={`submenu-nav-arrow submenu-nav-arrow--right ${canScrollRight ? 'is-active' : 'is-disabled'}`}
                    onClick={handleScrollRight}
                    disabled={!canScrollRight}
                    aria-label="Desplazar menú hacia la derecha"
                    title="Ver más opciones a la derecha"
                >
                    <FaChevronRight />
                </button>
            )}
        </div>
    );
};

export default Main;
